const webConfig = {};

webConfig.FILE_SERVER = ""; // file server domain
webConfig.PROJECT_NAME = "Land"; // used in get firestoreDb data
webConfig.WEB_NAME = "Land-Web"; // used in SignIn page
webConfig.API_BASE_URL = "https://api.daoyidh.com/land"; // api baseUrl

// Enable Anonymous login or not
webConfig.ENABLE_ANONYMOUS = false;

module.exports = webConfig;
